import { useCallback } from "react";
import LogService from "../../service/log/LogService";
// import {logEventBus} from "./inactivity/logEventBus";

const service = new LogService('logVideo');

/**
 * useVideoLogger
 *
 * Amacı:
 * - Video oynatıcıyla ilgili etkileşimleri (play, pause, seek, ended, buffering vb.)
 *   verilen assetId ile ilişkilendirerek sunucuya loglamak.
 * - Bu hook, bileşenlere tek bir `log(eventType, metadata?)` fonksiyonu döndürür.
 *
 * Parametreler:
 * - assetId: string | number — Log kayıtları için içerik/oturum kimliği.
 *
 * Dönüş Değeri:
 * - log: (eventType: string, metadata?: Record<string, any>) => void
 *   - Olay adını ve isteğe bağlı metadata bilgisini alır, `LogVideoService` üzerinden kaydeder.
 *   - Metadata JSON.stringify ile dizgeleştirilir.
 *
 * Loglanan Olaylar (eventType):
 * - 'initialized'      — İlk oynatma başlarken; player/screen bilgileriyle {speed, volume, muted, fullscreen, fullWidth, screenSize, videoPlaybackSize, time?, frameRate?, length?, devicePixelRatio?, userAgent?}
 * - 'played'           — Oynat tuşu ile başlatma/devam; { time }
 * - 'paused'           — Duraklatma; { time, progress }
 * - 'completed'        — Video bittiğinde; { time, progress }
 * - 'terminated'       — Bileşen unmount/oturum kapanışı; { time, progress }
 * - 'seeking'          — Sürgüyü basılı tutup hareket ettirme başlangıcı; { timeFrom }
 * - 'seeked'           — Seek bırakıldığında; { timeTo }
 * - 'rewind'           — 5 sn geri sarma; { timeFrom, timeTo }
 * - 'forward'          — 5 sn ileri sarma; { timeFrom, timeTo }
 * - 'speed'            — Oynatma hızı değişimi; { time, speed }
 * - 'volume'           — Ses seviyesini değiştirme (bırakıldığında); { time, volumeFrom, volumeTo }
 * - 'mute'             — Sessize alma; { time, muted: true }
 * - 'unmute'           — Sesi açma; { time, muted: false }
 * - 'fullscreen'       — Tam ekran aç/kapat; { time, fullscreen }
 * - 'fullWidth'        — Genişlik toggle; { time, fullWidth }
 * - 'mouseOnVideo'     — Fare ilk kez video üstüne geldiğinde; { time }
 * - 'mouseLeaveVideo'  — Fare video alanından ayrıldığında; { time }
 * - 'note'             — Not eklendiğinde; { time }
 *
 * Kısa Kullanım Örneği:
 *
 * const logVideo = useVideoLogger(assetId);
 *
 * // Oynat butonuna basıldığında
 * logVideo('played', { time: currentTime });
 *
 * // Duraklatıldığında
 * logVideo('paused', { time: currentTime, progress });
 *
 * // Seek yapıldığında
 * logVideo('seeked', { timeTo });
 */

export const useVideoLogger = (assetId) =>
    useCallback((eventType, metadata = {}) => {
        service.create({
            eventType,
            assetId,
            metadata: JSON.stringify(metadata),
        });

        // Etkinliği logEventBus ile yayınla
        // logEventBus.emit({ type: eventType, timestamp: Date.now() });
    }, [assetId]);
